import { NetworkStatus, useQuery } from '@apollo/client';

import { GetToolboxHighlightedOffersDocument } from './getToolboxHighlightedOffers.gql';

const useGetToolboxHighlightedOffers = () => {
  const { data, networkStatus, ...hook } = useQuery(
    GetToolboxHighlightedOffersDocument,
    { fetchPolicy: 'cache-and-network' },
  );

  const items = data?.toolboxHighlightedOffers.edges.map(({ node }) => node);
  const loading = networkStatus === NetworkStatus.loading;

  return {
    ...hook,
    items,
    loading,
  };
};

export default useGetToolboxHighlightedOffers;
